document.addEventListener('DOMContentLoaded', () => {
    // Shared Intersection Observer for all reveal animations
    const observerOptions = {
        root: null,
        rootMargin: '0px',
        threshold: 0.15
    };

    const revealCallback = (entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('is-visible');
                // Important: unobserve after showing once to mimic { once: true } in Framer Motion
                if (entry.target.dataset.once !== 'false') {
                    observer.unobserve(entry.target);
                }
            }
        });
    };

    const revealObserver = new IntersectionObserver(revealCallback, observerOptions);

    // Observe all elements with animation classes
    document.querySelectorAll('.fade-in-up, .fade-in, .reveal-on-scroll').forEach(element => {
        revealObserver.observe(element);
    });

    // Navigation Scroll Effect
    const header = document.querySelector('header.main-header');
    if (header) {
        window.addEventListener('scroll', () => {
            if (window.scrollY > 50) {
                header.classList.add('bg-brand-black/80', 'backdrop-blur-md', 'border-b', 'border-brand-white/5');
                header.classList.remove('bg-transparent', 'border-transparent');
            } else {
                header.classList.remove('bg-brand-black/80', 'backdrop-blur-md', 'border-b', 'border-brand-white/5');
                header.classList.add('bg-transparent', 'border-transparent');
            }
        });
    }
});
